import React from 'react';
import ServiceDetailPage from './ServiceDetailPage';
export default function LandscapeDesignMiami() {
  return <ServiceDetailPage slug="landscape-design-miami" />;
}
